
import React, { useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'

const WishlistButton = ({ courseId, isWishlisted }) => {
  const [wishlisted, setWishlisted] = useState(isWishlisted)
  const [loading, setLoading] = useState(false)

  const handleToggleWishlist = async () => {
    const token = localStorage.getItem('jwttoken')

    if (!courseId || !token) {
      console.error('Missing courseId or token.')
      return
    }

    const url = `https://kaasbackend.vetrinahealthcare.com/lms/user/wishlist/${courseId}/`
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }

    try {
      setLoading(true)

      if (wishlisted) {
        const response = await axios.delete(url, { headers })
        console.log('Delete response:', response.data)
        Swal.fire('Removed!', 'Course removed from wishlist', 'success')
        setWishlisted(false)
      } else {
        const response = await axios.post(url, {}, { headers })
        console.log('Post response:', response.data)
        Swal.fire('Added!', 'Course added to wishlist', 'success')
        setWishlisted(true)
      }
    } catch (error) {
      console.error('Error during wishlist toggle:', error.response || error)

      // Handle specific backend error and update UI
      if (
        error.response &&
        error.response.data &&
        error.response.data.error === 'Course is already in the wishlist.'
      ) {
        Swal.fire({
          icon: 'info',
          title: 'Already in Wishlist',
          text: 'This course is already in your wishlist.',
        })
        setWishlisted(true) // Update the button appearance
      } else {
        Swal.fire({
          icon: 'error',
          title: 'An error occurred. Please try again.',
        })
      }
    } finally {
      setLoading(false)
    }
  }

  const buttonStyle = {
    padding: '10px 16px',
    fontSize: '14px',
    borderRadius: '5px',
    border: 'none',
    cursor: loading ? 'not-allowed' : 'pointer',
    backgroundColor: wishlisted ? '#f5c6cb' : '#007bff',
    color: wishlisted ? '#721c24' : '#ffffff',
    transition: 'background-color 0.3s ease',
    opacity: loading ? 0.6 : 1,
  }

  return (
    <button onClick={handleToggleWishlist} style={buttonStyle} disabled={loading}>
      {loading
        ? 'Please wait...'
        : wishlisted
        ? 'Already Wishlisted'
        : 'Add to Wishlist'}
    </button>
  )
}

export default WishlistButton
